import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';
import { store } from 'store';

import { modalWindow } from 'components/common/modal/modal-window-reducer';
import { modal } from 'components/common/modal/modal-reducer';
import { loading } from 'components/common/loaders/loading-reducer';
import { plan } from 'components/join/reducers/plan';

// TODO remove share item page from router, combime item page reducer w/itemShare, reducer?
export const root: any = combineReducers({
  modal,
  modalWindow,
  toastr,
  plan,
  loading
});

export type RootState = ReturnType<typeof store.getState>;

export default root;
